import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M4 12h.01', key: '158zrr' }],
  ['path', { d: 'M4 16h.01', key: 'jrnfb7' }],
  ['path', { d: 'M4 20h.01', key: 'orx0iu' }],
  ['path', { d: 'M4 4h.01', key: 'cieki8' }],
  ['path', { d: 'M4 8h.01', key: '43g258' }],
  [
    'path',
    {
      d: 'M9.414 13.414a2 2 0 0 0 1.414.586H19a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-8.172a2 2 0 0 0-1.414.586L8 12z',
      key: '1pvxkf',
    },
  ],
  [
    'path',
    {
      d: 'M9.414 21.414a2 2 0 0 0 1.414.586H19a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-8.172a2 2 0 0 0-1.414.586L8 20z',
      key: '1k13gh',
    },
  ],
  [
    'path',
    {
      d: 'M9.414 5.414A2 2 0 0 0 10.828 6H19a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-8.172a2 2 0 0 0-1.414.586L8 4z',
      key: '12x0hd',
    },
  ],
];

/**
 * @component @name Timeline
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAxMmguMDEiIC8+CiAgPHBhdGggZD0iTTQgMTZoLjAxIiAvPgogIDxwYXRoIGQ9Ik00IDIwaC4wMSIgLz4KICA8cGF0aCBkPSJNNCA0aC4wMSIgLz4KICA8cGF0aCBkPSJNNCA4aC4wMSIgLz4KICA8cGF0aCBkPSJNOS40MTQgMTMuNDE0YTIgMiAwIDAgMCAxLjQxNC41ODZIMTlhMSAxIDAgMCAwIDEtMXYtMmExIDEgMCAwIDAtMS0xaC04LjE3MmEyIDIgMCAwIDAtMS40MTQuNTg2TDggMTJ6IiAvPgogIDxwYXRoIGQ9Ik05LjQxNCAyMS40MTRhMiAyIDAgMCAwIDEuNDE0LjU4NkgxOWExIDEgMCAwIDAgMS0xdi0yYTEgMSAwIDAgMC0xLTFoLTguMTcyYTIgMiAwIDAgMC0xLjQxNC41ODZMOCAyMHoiIC8+CiAgPHBhdGggZD0iTTkuNDE0IDUuNDE0QTIgMiAwIDAgMCAxMC44MjggNkgxOWExIDEgMCAwIDAgMS0xVjNhMSAxIDAgMCAwLTEtMWgtOC4xNzJhMiAyIDAgMCAwLTEuNDE0LjU4Nkw4IDR6IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/timeline
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const Timeline = createLucideIcon('timeline', __iconNode);

export default Timeline;
